import { AppConfig } from '../types/AppConfig'
import { InitApp, SetLocale } from '../actions/commonActions'
import { INIT_APP, SELECT_ACCOUNT } from '../constants'
import { SelectAccount, SetAccount } from '../actions'
import * as constants from '../constants'

export function appConfig(
  state: AppConfig = defaultState,
  action: InitApp | SelectAccount | SetAccount | SetLocale | any
): AppConfig {
  switch (action.type) {
    case INIT_APP: {
      const { type, ...newState } = action
      return { ...state, ...newState }
    }
    case constants.SET_ACCOUNT:
      return { ...state, accountLogin: action.account.login }
    case SELECT_ACCOUNT: {
      return { ...state, accountLogin: action.accountId }
    }
    case constants.SET_LOCALE: {
      const locale = action.locale
      return locale ? { ...state, locale: action.locale } : { ...state }
    }
    default:
      return state
  }
}
export const defaultState: AppConfig = {
  accountLogin: '',
  authToken: undefined,
  defaultSymbol: 'EURUSD',
  demo: undefined,
  graphQlURL: process.env.REACT_APP_DEFAULT_API_URL || '',
  locale: 'en',
  mode: 'normal',
  mt4Platform: 'web',
  mt4Version: 4,
  preferredAccountType: 'forex',
}
